import { useCallback, useState } from "react";
import apiClient from "../api/apiClient";

type SelResponse = any; // Replace with real response type later

interface UseSelScoreReturn {
  data: SelResponse | null;
  loading: boolean;
  error: string | null;
  fetchClassSel: (schoolId: string, grade: string) => Promise<void>;
  fetchStudentSel: (
    schoolId: string,
    grade: string,
    studentId: string
  ) => Promise<void>;
  reset: () => void;
}

const useSelScore = (): UseSelScoreReturn => {
  const [data, setData] = useState<SelResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchClassSel = useCallback(async (schoolId: string, grade: string) => {
    try {
      setLoading(true);
      setError(null);

      const response = await apiClient.get(
        `/selScore/class/${schoolId}/${grade}`
      );

      setData(response.data);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to fetch SEL data");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStudentSel = useCallback(
    async (schoolId: string, grade: string, studentId: string) => {
      try {
        setLoading(true);
        setError(null);

        const response = await apiClient.get(
          `/selScore/student/${schoolId}/${grade}/${studentId}`
        );

        setData(response.data);
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch student SEL");
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const reset = () => {
    setData(null);
    setError(null);
    setLoading(false);
  };

  return {
    data,
    loading,
    error,
    fetchClassSel,
    fetchStudentSel,
    reset,
  };
};

export default useSelScore;
